import React, {Component} from "react";
import PopupAdminHomework from "../../../Containers/PopupAdminHomework/index";
import PagingBtn from "../../../Buttons/PagingBtn/index";
import * as AdminHomeworkService from "../../../../services/Teacher/AdminHomeworkService";
import * as AdminClassroomService from "../../../../services/Teacher/AdminClassroomService";
import Moment from "moment";

class AdminManagementHomework extends Component {
    state = {
        curPageHomeworkList: [],
        showCreatePopup: false,
        showUpdatePopup: false,
        selectItem: null,
        itemRange: 30,
        selectSubject: "전체 보기(과목)",
        selectClassroom: null,
        groupcheck: false,
    }

    constructor() {
        super();

        this.curPage = 0;
        this.optionItemRange = [
            {id: 0, text: "전체 보기(1000개)", value: 1000},
            {id: 1, text: "30개씩 보기", value: 30},
            {id: 2, text: "50개씩 보기", value: 50},
        ];

        this.optionSubject = [
            {id: -1, subject: "전체 보기(과목)"},
            {id: 0, subject: "vocabulary"},
            {id: 1, subject: "writing"},
            {id: 2, subject: "listening"},
            {id: 3, subject: "speaking"}
        ];

        this.classrooms = ['전체 보기(학급)'];
        this.searchValue = null;
        this.selectHomeworks = [];

        this.sortBy = 'id';
        this.sortCreatedDateDirection = 'DESC';
        this.sortDueDateDirection = 'DESC';
    }

    componentDidMount = () => {
        const {selectClassroom, selectSubject} = this.state;
        this.getClassroomCategory();
        this.getHomeworkPaging(selectClassroom, selectSubject); //테스트중
    }

    getHomeworkPaging = (classroom, subject, sortSize) => {
        const pageVO = {
            page: this.curPage,
            size: (sortSize == null) ? this.state.itemRange : sortSize,
            direction: (this.sortBy == 'id')? 'DESC' : (this.sortBy == 'createdDate') ? this.sortCreatedDateDirection : this.sortDueDateDirection,
            sortBy: this.sortBy
        };

        AdminHomeworkService.getHomeworkList(classroom, (subject == '전체 보기(과목)') ? null : subject, this.searchValue, pageVO).then((response) => {
            if (response.status === 200) {
                let responseData = response.data;
                if (responseData.code === '0000') {
                    this.totalPages = responseData.data.totalPages;
                    this.homeworkList = responseData.data.result;
                    this.setState({curPageHomeworkList: this.homeworkList, groupcheck: false});
                } else if (responseData.code == '0001') {
                    this.totalPages = 0;
                    this.homeworkList = [];
                    this.setState({curPageHomeworkList: this.homeworkList});
                } else {
                    alert(responseData.data);
                }
            } else {
                alert('GET HOMEWORK ERROR');
            }
        }).catch(response => {
            alert("SERVER ERROR");
        });
    }

    getClassroomCategory = () => {
        AdminClassroomService.getClassroomCategory()
            .then((response) => {
                if (response !== null && response.status === 200) {
                    let temp = this.classrooms;
                    let sortArray = response.data.data.sort(function (a, b) {
                        var nameA = a.toLowerCase(), nameB = b.toLowerCase();
                        if (nameA < nameB)
                            return -1;
                        if (nameA > nameB)
                            return 1;
                        return 0;
                    });

                    temp = temp.concat(sortArray);
                    this.classrooms = temp;
                }
            }).catch((error) => {
            console.log(error);
            alert('SERVER ERROR');
        });
    }

    // 옵션 세팅
    setOptionItemRange = () => {
        return (
            <div className="wrap-select">
                <span></span>
                <select id="itemRangeSelect" onChange={this.onClickOptionItemRange} value={this.state.itemRange}>
                    {this.optionItemRange.map(
                        (item) => (<option key={item.id} value={item.value}>{item.text}</option>)
                    )}
                </select>
            </div>
        );
    }

    onClickOptionItemRange = (e) => {
        const {selectClassroom, selectSubject} = this.state;
        this.setState({itemRange: e.target.value});
        this.getHomeworkPaging(selectClassroom, selectSubject, e.target.value);
    }

    setOptionSubject = () => {
        return (
            <div className="wrap-select">
                <span></span>
                <select id="subject" onChange={this.onClickOptionSubject} value={this.state.selectSubject}>
                    {this.optionSubject.map(
                        (item) => (<option key={item.id} value={item.subject}>{item.subject}</option>)
                    )}
                </select>
            </div>
        );
    }

    onClickOptionSubject = (e) => {
        const {selectClassroom} = this.state;
        this.setState({selectSubject: e.target.value});
        this.getHomeworkPaging(selectClassroom, e.target.value);
    }

    setOptionClassroom = () => {
        return (
            <div className="wrap-select" onChange={this.onClickOptionClassroom}>
                <span></span>
                <select>
                    { this.classrooms.map((classroomName, i) => {
                        return <option key={i}>{classroomName}</option>
                    })}
                </select>
            </div>
        );
    }

    onClickOptionClassroom = (e) => {
        const {selectSubject} = this.state;
        this.setState({selectClassroom: (e.target.value == '전체 보기(학급)') ? null : e.target.value});
        this.getHomeworkPaging((e.target.value == '전체 보기(학급)') ? null : e.target.value, selectSubject);
    }

    // input 데이터 저장
    onInputValueChanged = (e) => {
        this.inputValue = e.target.value
    }

    // 학생 이름으로 검색
    onSearch = () => {
        const {selectClassroom, selectSubject} = this.state;
        if (this.inputValue == null || this.inputValue.length == 0) {
            this.searchValue = null;
        } else {
            this.searchValue = this.inputValue;
        }
        this.getHomeworkPaging(selectClassroom, selectSubject);
    }

    setPage = () => {
        const {curPageHomeworkList} = this.state;
        const list = curPageHomeworkList.map(
            (item, i) => (
                <tr key={i}>
                    <td>
                        <div className="wrap-chbox">
                            <input type="checkbox" checked={(item.checked == undefined) ? false : item.checked}
                                   onChange={(e) => this.checkItem(i, e.target.checked)}/>
                            <span></span>
                        </div>
                    </td>
                    <td>{item.homework.id}</td>
                    <td>{(item.homework.classroom == null) ? '-' : item.homework.classroom.classroomName}</td>
                    <td>{(item.homework.user == null) ? '-' : item.homework.user.name}</td>
                    <td>{item.homework.subject}</td>
                    <td>{item.homework.title}</td>
                    <td>{Moment(item.homework.createdDate).format('YYYY-MM-DD')}</td>
                    <td>{Moment(item.homework.dueDate).format('YYYY-MM-DD')}</td>
                    <td>
                        <a className="btn-sm deepPink" onClick={() => this.showUpdateHomeworkPopup(item)}>조회/수정/삭제</a>
                    </td>
                </tr>
            )
        );
        return list;
    }

    showUpdateHomeworkPopup = (item) => {
        this.setState({
            showUpdatePopup: true,
            showCreatePopup: false,
            selectItem: item
        });
    }

    closeUpdateHomeworkPopup = () => {
        this.setState({
            showUpdatePopup: false,
            showCreatePopup: false,
            selectItem: null
        });

        const {selectClassroom, selectSubject} = this.state;
        this.getHomeworkPaging(selectClassroom, selectSubject);
    }

    showHomeworkPopup = () => {
        this.setState({
            showCreatePopup: true,
            showUpdatePopup: false,
            selectItem: null
        });
    }

    closeHomeworkPopup = () => {
        this.setState({
            showCreatePopup: false,
            showUpdatePopup: false,
            selectItem: null
        });

        const {selectClassroom, selectSubject} = this.state;
        this.getHomeworkPaging(selectClassroom, selectSubject);
    }

    onUpdatePage = (page) => {
        const {selectClassroom, selectSubject} = this.state;
        this.curPage = page;
        this.getHomeworkPaging(selectClassroom, selectSubject);
    }

    onClickSortCreatedDate = () => {
        const {selectClassroom, selectSubject} = this.state;
        this.sortCreatedDateDirection = (this.sortCreatedDateDirection == 'DESC') ? 'ASC' : 'DESC';
        this.sortBy = 'createdDate';
        this.getHomeworkPaging(selectClassroom, selectSubject);
    }

    onClickSortDueDate = () => {
        const {selectClassroom, selectSubject} = this.state;
        this.sortDueDateDirection = (this.sortDueDateDirection == 'DESC') ? 'ASC' : 'DESC';
        this.sortBy = 'dueDate';
        this.getHomeworkPaging(selectClassroom, selectSubject);
    }

    checkGroup = (e) => {
        const {curPageHomeworkList} = this.state;

        for (let i = 0; i < curPageHomeworkList.length; i++) {
            curPageHomeworkList[i].checked = e.target.checked;
        }

        this.selectHomeworks = curPageHomeworkList.filter(x => x.checked);
        this.setState({curPageHomeworkList: curPageHomeworkList, groupcheck: e.target.checked});
    }

    checkItem = (index, checked) => {
        const {curPageHomeworkList} = this.state;
        curPageHomeworkList[index].checked = checked;
        this.selectHomeworks = curPageHomeworkList.filter(x => x.checked);
        this.setState({curPageHomeworkList: curPageHomeworkList});
    }

    getHomeworkIds = () => {
        let homeworkIds = '';
        for (let i = 0; i < this.selectHomeworks.length; i++) {
            if (i > 0) homeworkIds += ',';
            homeworkIds += this.selectHomeworks[i].homework.id;
        }

        return homeworkIds;
    }

    deleteHomeworkGroup = () => {
        const {selectClassroom, selectSubject} = this.state;
        AdminHomeworkService.deleteHomeworks(this.getHomeworkIds())
            .then((response) => {
                if (response !== null && response.status === 200) {
                    this.selectHomeworks = [];
                    this.getHomeworkPaging(selectClassroom, selectSubject); //테스트중
                }
            }).catch((error) => {
            console.log(error);
            alert('SERVER ERROR');
        });
    }

    render() {
        const {showCreatePopup, showUpdatePopup, selectItem} = this.state;

        if (this.homeworkList == null)
            return null;

        return (
            <div className="wrap-rCon">
                <PopupAdminHomework active={showCreatePopup} isUpdateMode={false} selectItem={null}
                                    onClose={this.closeHomeworkPopup}/>
                <PopupAdminHomework active={showUpdatePopup} isUpdateMode={true} selectItem={selectItem}
                                    onClose={this.closeUpdateHomeworkPopup}/>
                <div className="wrap-top">
                    <a className="baseBtn undefined blue" onClick={this.showHomeworkPopup}><span>숙제 부여하기</span></a>
                    <a className="baseBtn deepPink" onClick={() => this.deleteHomeworkGroup()}>선택 삭제</a>
                    <div className="box-rfix">
                        {this.setOptionItemRange()}
                        {this.setOptionSubject()}
                        {this.setOptionClassroom()}
                        <div className="wrap-search">
                            <input className="ip-basic" type="text" placeholder="학생 이름 검색"
                                   onChange={this.onInputValueChanged}/>
                            <a className="btn-sm yellow" onClick={() => this.onSearch()}>검색</a>
                        </div>
                    </div>
                </div>

                <div className="tb-scroll">
                    <table className="tb-basic">
                        <colgroup>
                            <col width="3%"/>
                            <col width="7%"/>
                            <col width="10%"/>
                            <col width="10%"/>
                            <col width="10%"/>
                            <col width="10%"/>
                            <col width="15%"/>
                            <col width="15%"/>
                            <col width="12%"/>
                        </colgroup>
                        <thead>
                        <tr>
                            <th>
                                <div className="wrap-chbox">
                                    <input type="checkbox" onChange={this.checkGroup} checked={this.state.groupcheck}/>
                                    <span></span>
                                </div>
                            </th>
                            <th>-</th>
                            <th>학급명</th>
                            <th>학생명</th>
                            <th>과목</th>
                            <th>제목</th>
                            <th>
                                숙제 등록일
                                <a className="btn-sort" onClick={this.onClickSortCreatedDate}></a>
                            </th>
                            <th>
                                숙제 부여일
                                <a className="btn-sort" onClick={this.onClickSortDueDate}></a>
                            </th>
                            <th>조회/수정/삭제</th>
                        </tr>
                        </thead>
                        <tbody>{this.setPage()}</tbody>
                    </table>
                </div>
                <PagingBtn currentPage={this.curPage} totalPages={this.totalPages} onUpdatePage={this.onUpdatePage}/>
            </div>
        );
    }
}
export default AdminManagementHomework;



// WEBPACK FOOTER //
// ./src/components/Pages/Teacher/AdminManagement/Homework.js